<template>
    <PopularGamesMain />
</template>

<script>
import PopularGamesMain from '@/components/slots/PopularGamesMain.vue';

export default {
    name: 'Popular',
    components: {
        PopularGamesMain
    },
    metaInfo: {
        title: 'Popular - Inout, Hacksaw, Caleta Games'
    }
};
</script>
